module.exports = __webpack_public_path__ + "images/8adb91c2c5ec397901426d77052e873f.png";